import type { RailingCatalogSettings } from "building-types/settings/railingCatalogSettings";
import type { RailingDefaultSetting } from "building-types/settings/railingTypes";
import type { FeatureSet } from "common/constants/features";
import type { Table } from "common/data/table";
import objectFilter from "common/utils/objectFilter";
import { defaultRailingSetting, defaultRailingSettingKey } from "./constants";

export const builtInRailingSettings: Table<RailingDefaultSetting> = {
  [defaultRailingSettingKey]: defaultRailingSetting,
};

/**
 * Dual-read helper, mirroring stairs' `getStairCatalog` (BDG-2943): with `settingsToCatalogs` on,
 * `doc.railingCatalog` entries win over the legacy settings-nested `railingSettingsTable` on id
 * collision; with the flag off (or no doc table entries yet), resolution is identical to the
 * pre-migration behavior.
 */
export function getRailingCatalog(
  railingCatalogSettings: RailingCatalogSettings | undefined,
  railingCatalog?: Table<RailingDefaultSetting>,
  enabledFeatures?: FeatureSet,
): Table<RailingDefaultSetting> {
  if (enabledFeatures?.settingsToCatalogs && railingCatalog) {
    const legacySettings = objectFilter(
      railingCatalogSettings?.railingSettingsTable ?? {},
      (entry) => !(entry.id in builtInRailingSettings),
    );
    return { ...legacySettings, ...railingCatalog };
  }

  return railingCatalogSettings?.railingSettingsTable ?? {};
}
